<template>
  <div class="couponadd" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <ul class="lsls first">
      <li>
        <h2>{{detail.title}}</h2>
      </li>
      <li>
        <span>产品名称</span>
        <input type="text" v-model="title" placeholder="请填写产品名称"/>
      </li>
      <li>
        <span>产品原价</span>
        <input type="number" v-model="price" placeholder="请输入产品原价"/>
        <font>元</font>
      </li>
      <li>
        <span>优惠价</span>
        <input type="number" v-model="rate" placeholder="请输入优惠价"/>
        <font>元</font>
      </li>
      <li>
        <span>产品简介</span>
        <input type="text" v-model="jianj" placeholder="请输入产品简介"/>
      </li>
      <li>
        <span>产品介绍</span>
        <input type="text" v-model="content" placeholder="请输入产品介绍"/>
      </li>
      <li @click="chooseCate">
        <span>所属分类</span>
        <input type="text" :value="msg" readonly placeholder="请选择所属分类"/>
        <img class="icon" src="~assets/images/icon5.png" style="top:55px" />
      </li>
    </ul>
    <ul class="lsls">
      <li @click="getQquey13">
        <span>产品介绍图<i style="font-size:12px;color:#666;font-style: normal">（请上传 640 × 480 格式图片）</i></span>
        <img class="icon" src="~assets/images/icon5.png" />
        <img v-for="(item,i) in img" class="imgs" :src="baseUrl+item" />
      </li>
    </ul>

    <button class="addAddress" @click="save123">立即发行</button>
    <div style="height:30px"></div>


    <el-drawer
      title="选择产品分类" :visible.sync="drawer" :direction="direction" size="55%" :withHeader="true">
      <ul>
        <li v-for="(item,i) in cate">
          <p><b @click="catec(i,item.id,item.title)">{{item.title}}</b><font @click="delcate(item.id)">删除</font></p>
          <a @click="catec(i,item.id,item.title)" v-if="i==active"><img src="~assets/images/choose2.png" /></a>
          <a @click="catec(i,item.id,item.title)" v-if="i!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
        <li><button @click="addcate">添加分类</button></li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        cate:[],
        detail:[],
        title:'',
        price:'',
        rate:'',
        jianj:'',
        content:'',
        img:[],
        direction: 'btt',
        drawer:false,
        active:-1,
        msg:'',
        cate_id:0,
        pro_id:'',
        setpro:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var pro_id = this.$route.query.pro_id;
      this.pro_id = pro_id
      if(pro_id > 0){
        this.getpro();
      }
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.proCate();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      chooseCate:function(){
        this.drawer = true;
      },
      catec:function(i,id,title){
        this.active = i;
        this.cate_id = id;
        this.msg = title;
        this.drawer = false;
      },
      delcate:function(id){
        var that = this;
        that.fullscreenLoading = true;
        that.$confirm('此操作将删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios({
            method:'post',
            url:that.$host+'home/product/delCate',
            params:{
              id:id
            }
          }).then(function(response){
            that.proCate();
            that.fullscreenLoading = false
          }).catch(err=>{
            console.log('请求失败:'+err);
            that.fullscreenLoading = false
          });
        }).catch(() => {
          that.fullscreenLoading = false;
        });
      },
      addcate:function(){
        var that = this;
        var id = that.$route.query.id;
        that.fullscreenLoading = true;
        that.$prompt('请输入分类名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {

          that.fullscreenLoading = false;
          if(value == null){
            that.$alert('请输入分类名称', '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          
          that.axios({
            method:'post',
            url:that.$host+'home/product/addCate',
            params:{
              id:id,
              title:value
            }
          }).then(function(response){
            that.proCate();
            that.fullscreenLoading = false
          }).catch(err=>{
            console.log('请求失败:'+err);
            that.fullscreenLoading = false
          });
        }).catch(() => {
          that.fullscreenLoading = false;
        });
      },
      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/getBusiness',
          params:{
            id:id
          }
        }).then(function(response){
          that.detail = response.data.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      proCate:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/proCate',
          params:{
            b_id:id
          }
        }).then(function(response){
          that.cate = response.data.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getpro:function(){
        var that = this;
        var id = this.$route.query.pro_id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/productDetail',
          params:{
            id:id
          }
        }).then(function(response){
          var rs = response.data.data;
          that.title = rs.title;
          that.price = rs.price;
          that.rate = rs.rate;
          that.jianj = rs.jianj;
          that.content = rs.content;
          that.img = rs.img;
          that.msg = rs.ctitle;
          that.cate_id = rs.cate_id;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      save123:function(){
        var that = this;
        var b_id = that.$route.query.id;
        if(that.title == ''){
          alert('请填写产品名称');
          return false;
        }
        if(that.price == ''){
          alert('产品原价');
          return false;
        }
        if(that.rate == ''){
          alert('请输入优惠价');
          return false;
        }
        if(that.jianj == ''){
          alert('请输入产品简介');
          return false;
        }
        if(that.content == ''){
          alert('请输入产品介绍');
          return false;
        }
        if(that.cate_id == ''){
          alert('请选择所属分类');
          return false;
        }
        if(that.img.length <= 0){
          alert('请选择产品介绍图');
          return false;
        }
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/addPro',
          params:{
            id:that.pro_id,
            title:that.title,
            price:that.price,
            rate:that.rate,
            jianj:that.jianj,
            content:that.content,
            cate_id:that.cate_id,
            img:JSON.stringify(that.img),
            b_id:b_id
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            that.$router.go(-1)
          }else{
            alert(res.message);
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },

      getQquey13:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['album', 'camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s)
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/product/upload',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.img.push(msg.data);
            }else{
              alert('上传失败');
            }
            that.fullscreenLoading = false;
          }
        })
      },

    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .couponadd{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .couponadd ul.lsls{
    display:block;
    width:93%;
    background:#fff;
    margin:0 auto;
    margin-bottom:50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .couponadd ul.first{
    margin-bottom:15px;
  }
  .couponadd ul.lsls li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0;
    position: relative;
  }
  .couponadd ul.lsls li font{
    position:absolute;
    right:15px;
    bottom:15px;
    font-size:16px;
    color:#FF751A
  }
  .couponadd ul.lsls li .icon{
    position:absolute;
    right:10px;
    top:20px;
    width:8px
  }
  .couponadd ul.lsls li:first-child{
    border-bottom:none;
  }
  .couponadd ul li:first-child h2{
    font-size:18px
  }
  .couponadd li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .couponadd ul li span{
    display:block;
    width:100%;
    font-size:16px;
    padding-bottom:15px
  }
  .couponadd ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:16px;
    margin-top:1px;
  }
  .couponadd ul li .imgs{
    width:31%;
    margin-right:2%
  }
  .couponadd ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }
  .couponadd ul li textarea{
    float:left;
    width:78%;
    height:50px;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    resize: none;
  }
  .couponadd .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }

  .couponadd .el-drawer{
    overflow-y: scroll;

  }
  .couponadd .el-drawer .el-drawer__header{
    margin-bottom:0;
    position: fixed;
    width:90%;
    background:#fff !important;
    z-index:999;
    padding:10px 20px
  }
  .couponadd .el-drawer__wrapper ul{
    width:90%;
    margin:20px auto;
    padding-top:20px
  }
  .couponadd .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .couponadd .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .couponadd .el-drawer__wrapper li p{
    padding-bottom:7px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }

  .couponadd .el-drawer__wrapper li button{
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
    display:block;
    border:none;
    margin:0 auto;
    width:80%;
    padding:10px 0;
    margin-top:20px
  }
  .couponadd .el-drawer__wrapper li p font{
    float:right;
    font-size:14px;
    color:#f00
  }
  .couponadd .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .couponadd .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .couponadd .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

</style>